import { executeRequest, Request } from '@jfs/network'
import { generateOtpOnNonIDAM, getOtpRequestBody } from './../data/request/requestbody'
import { OtpParser } from './../network/parsers/GetOtpParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = OtpParser(data)
  return respData
}

const generateOTP = (mobileNumber: string, tokens: any, reqBody?: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtp,
    method: 'POST',
    config: sitConfig(tokens),
    body: reqBody ? reqBody : getOtpRequestBody(mobileNumber),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const generateOtpOnNonIDAMReq = (mobileNumber: string, tokens: any) => {
  console.log('===> generateOtpOnNonIDAMReq', mobileNumber, tokens)
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtp,
    method: 'POST',
    config: sitConfig(tokens),
    body: generateOtpOnNonIDAM(mobileNumber),
  }
  return executeRequest(request).then((data) => {
    return data.data
  })
}

export { generateOTP, generateOtpOnNonIDAMReq }
